export default __webpack_public_path__ + "static/media/WhatsappAppIcon.e647d712.svg";